import React, { useState } from "react";
import { useSelector } from "react-redux";
import { FcIdea } from "react-icons/fc";
import { FiUsers, FiCalendar, FiEye, FiCheckCircle } from "react-icons/fi";
import moment from "moment";
import { Link } from "react-router-dom";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import ResponseModel from "./responseModel/ResponseModel";
import "./DashboardListingsNew.css";

const AllRespond = ({ searchTerm = "" }) => {
  const { userViewRespond = [] } = useSelector((store) => store.UserViewProperty);

  const [modal, setModal] = useState(false);
  const [singleProperty, setSingleProperty] = useState("");
  const toggle = () => setModal(!modal);

  const closePropDetailModal = () => {
    setModal(false);
  };

  const viewRespondClick = (e, property) => {
    if (e) e.preventDefault();
    setSingleProperty(property);
    setModal(true);
  };

  const filteredRespond = (userViewRespond || []).filter((item) => {
    if (!searchTerm || !searchTerm.trim()) return true;
    const term = searchTerm.toLowerCase().trim();
    return (
      (item.propertyName && item.propertyName.toLowerCase().includes(term)) ||
      (item.propertyId && String(item.propertyId).toLowerCase().includes(term)) ||
      (item.propertyStatus && item.propertyStatus.toLowerCase().includes(term))
    );
  });

  return (
    <div className="mgh-dl-container">
      {/* ================= Header Info Bar ================= */}
      <div className="mgh-dl-info-bar">
        <h4 className="mgh-dl-count-heading">
          <span>Direct Responses & Inquiries</span>
          <span className="mgh-dl-count-pill">
            {filteredRespond.length}{" "}
            {filteredRespond.length === 1 ? "Response" : "Responses"}
          </span>
        </h4>

        <div className="mgh-dl-filters-row">
          <span className="mgh-dl-filter-tag">
            <span>Showing: Direct Responses</span>
          </span>
        </div>
      </div>

      {/* ================= Response Model Modal ================= */}
      <Modal isOpen={modal} toggle={toggle} className="modalmainnew" centered>
        <div className="model-wrappernew">
          <ModalHeader toggle={toggle}>Response Details</ModalHeader>
          <ModalBody>
            <ResponseModel
              closePropdet={closePropDetailModal}
              propertyprop={singleProperty}
            />
          </ModalBody>
        </div>
      </Modal>

      {/* ================= Responses List ================= */}
      {filteredRespond.length > 0 ? (
        filteredRespond.map((view, index) => (
          <div className="mgh-lead-card" key={view._id || index}>
            <div className="mgh-lead-card-main">
              <div className="mgh-lead-prop-wrap">
                {view.propertyId && (
                  <span className="mgh-lead-prop-id">
                    ID: {String(view.propertyId).slice(0, 8)}
                  </span>
                )}
                <h5 className="mgh-lead-prop-title">
                  {view.propertyName || "Property Listing"}
                </h5>
                <p className="mgh-lead-prop-price">
                  {view.price
                    ? `Rs. ${Number(view.price).toLocaleString("en-IN")}`
                    : "Price on Request"}
                </p>
              </div>

              <div className="mgh-lead-score-wrap">
                <p className="mgh-lead-date-label">
                  <FiCalendar size={13} style={{ marginRight: "4px" }} />
                  Posted: {moment(view.createdAt).format("DD MMM YYYY")}
                </p>
                {view.ExpiryDate && (
                  <p className="mgh-lead-date-label" style={{ color: "#ea580c" }}>
                    Expires: {moment(view.ExpiryDate).format("DD MMM YYYY")}
                  </p>
                )}
              </div>

              <div className="mgh-lead-prop-wrap">
                <p className="mgh-lead-buyer-contact">
                  <FiEye size={14} color="#ea580c" />
                  <span>Views: {view.noofviews || 0}</span>
                </p>
                <span
                  className={
                    view.propertyStatus === "Active"
                      ? "mgh-lead-verified-badge"
                      : "mgh-dl-pkg-badge"
                  }
                  style={{ width: "fit-content" }}
                >
                  <FiCheckCircle size={11} /> {view.propertyStatus || "Active"}
                </span>
              </div>
            </div>

            <div className="mgh-lead-footer">
              <div className="d-flex align-items-center gap-2">
                <FcIdea size={18} />
                <span style={{ fontSize: "12.5px", color: "#475569" }}>
                  Need more buyers/tenants? Check out our lead plans.
                </span>
              </div>

              <button
                type="button"
                className="mgh-lead-btn mgh-lead-btn-call"
                onClick={(e) => viewRespondClick(e, view)}
              >
                View Details
              </button>
            </div>
          </div>
        ))
      ) : (
        <div className="mgh-dl-empty-state">
          <div className="mgh-dl-empty-icon">
            <FiUsers size={28} />
          </div>
          <h3 className="mgh-dl-empty-title">No Direct Responses Yet</h3>
          <p className="mgh-dl-empty-desc">
            You don't have any direct inquiries logged for this filter.
            Keep your properties active to generate more inquiries!
          </p>
          <div
            style={{
              display: "flex",
              gap: "10px",
              flexWrap: "wrap",
              justifyContent: "center",
              marginTop: "4px",
            }}
          >
            <Link
              to="/postPropertyHome"
              className="mgh-dl-boost-btn"
              style={{ textDecoration: "none" }}
            >
              + Post Property FREE
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default AllRespond;
